<template>
<div class="text-gray-dark flex flex-col overflow-x-hidden">
  <span v-if="answerExamplesLoaded">
    Examples for
    <router-link :to="`/bots/${bot.id}/answers/${answerId}`"
                 target="_blank"
                 class="hover:underline"
    >
      {{ suggestedAnswerName }}
    </router-link> answer:
  </span>

  <intent-suggestion-examples-list v-if="intentId"
                                   :intent-id="intentId"
                                   class="pr-5"
                                   @intent-examples-loaded="hasLoaded => answerExamplesLoaded = hasLoaded"
  />
</div>
</template>

<script>
import IntentSuggestionExamplesList from '@/components/common/IntentSuggestionExamplesList.vue'
import analyticsFilterModule from '@/store/modules/analytics-filter.module'

export default {
  name: 'AnswerSuggestionExamples',
  components: { IntentSuggestionExamplesList },
  props: {
    intentId: {
      type: String
    },
    suggestedAnswerName: {
      type: String
    },
    answerId: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      answerExamplesLoaded: false
    }
  },

  computed: {
    bot: analyticsFilterModule.getBot
  }
}
</script>
